import React, { useEffect, useState } from "react";

import {
  UpdatesLabel,
  GridContainerTemplates,
  Container,
  Header
} from "./styles";
import Template from "../components/Template";
import SearchBar from "../components/SearchBar";
import api from "../../../services/api";
import LoadingEditor from "../../editor/components/LoadingEditor";
import { useHeaderEditor } from "../../editor/hooks/headerEditor";
import TemplatesItem from "../components/TemplatesItem";
import BlankProjectDefault from "../components/BlankProjectDefault";
import { useNavigate } from "react-router-dom";
import cloneDeep from "lodash/cloneDeep";
import { useMainHook } from "../../../hooks/main";
import { VerticalStack } from "../../editor/components/SearchInput/styles";
import { FlexPagination } from "../../myclausules/screen/styles";
import Pagination from "../../../shared/components/Pagination";
import {
  BoxSearch,
  ButtonSearch,
  ContainerIcon,
  ContainerInput,
  WrapperInput
} from "../../myprojects/screen/styles";
import { ContractAnimation } from "../../../shared/components/ContractAnimation";
import { LoadingFlex } from "../../accountUser/components/ChangePassword/styles";

interface ParamsProps {
  pagination: number;
  search: string;
}

interface IScreenCreateNewProject {
  bits_template_category_id: string;
  created_at: string;
  creator_id: string;
  description: string;
  id: string;
  key_words: string;
  last_editor_id: string;
  template: {
    arrayOfPages: any[];
  };
  thumbnail: string;
  thumbnail_url: string;
  title: string;
  updated_at: string;
  usage_counter: number;
}

const ScreenCreateNewProject: React.FC = () => {
  const navigator = useNavigate();
  const [loading, setLoading] = useState(false);
  const [templatesBits, setTemplatesBits] = useState<IScreenCreateNewProject[]>(
    []
  );
  const { handleCreateNewProject } = useHeaderEditor();
  const [params, setParams] = useState<ParamsProps>({
    pagination: 0,
    search: ""
  });
  const { objectScreen, setObjectScreen, documentName } = useMainHook();
  const [totalPages, setTotalPages] = useState(0);
  const [search, setSearch] = useState("");

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const response = await api.get("bits-templates", {
          params: {
            pagination: params.pagination,
            search: params.search ? params.search : null
          }
        });
        setTemplatesBits(response.data.dataArray);
        setTotalPages(response.data.pagination);
        setLoading(false);
      } catch (err) {
        console.log(err);
      }
    })();
  }, [params]);

  const chooseTemplateBits = async (id: string) => {
    let selectedTemplate = [];
    try {
      const responseSpecific = await api.get(`bits-templates/${id}`);
      selectedTemplate.push(
        ...responseSpecific.data.bits_template.template.arrayOfPages
      );
    } catch (err) {
      console.log(err, "error when get specific template");
    }

    setObjectScreen(state => {
      let cloneState = cloneDeep(state);
      cloneState = selectedTemplate;
      return cloneState;
    });

    if (selectedTemplate.length > 0) {
      try {
        const newProject = {
          template: {
            arrayOfPages: selectedTemplate
          },
          title: "Novo documento",
          description: "Criando novo projeto de template",
          is_automation: false
        };

        documentName.current = `${newProject.title}`;

        const requestNewProject = await api.post("/user-templates", newProject);
        navigator(`/editor/my-template/${requestNewProject.data.id}`);
      } catch (err) {
        console.log(err, "error when choose template");
      }
    }
  };

  const handleSearchDocument = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setSearch(event.target.value);
    },
    [search]
  );

  const handleSearching = React.useCallback(() => {
    setParams(state => {
      return {
        ...state,
        search: search
      };
    });
  }, [params, search]);

  return (
    <>
      {loading ? (
        <LoadingFlex>
          <ContractAnimation />
        </LoadingFlex>
      ) : (
        <Container>
          <Header>
            <UpdatesLabel>Criar novo projeto</UpdatesLabel>
          </Header>

          <BoxSearch>
            <WrapperInput>
              <ContainerIcon>
                <img
                  src={"./images/icon-search.svg"}
                  className="icon-search-input"
                  alt=""
                />
              </ContainerIcon>
              <ContainerInput>
                <input
                  type="text"
                  value={search}
                  onChange={handleSearchDocument}
                />
              </ContainerInput>
            </WrapperInput>
            <ButtonSearch onClick={handleSearching}>PESQUISAR</ButtonSearch>
          </BoxSearch>

          <GridContainerTemplates>
            {params.pagination === 0 && (
              <BlankProjectDefault
                text="Em branco"
                onClick={handleCreateNewProject}
              />
            )}

            {templatesBits.map(template => (
              <TemplatesItem
                key={template.id}
                src={template.thumbnail_url}
                text={template.title}
                onClick={() => chooseTemplateBits(template.id)}
              />
            ))}
          </GridContainerTemplates>

          <div
            style={{
              width: "100%",
              minHeight: "90px",
              display: "flex",
              marginTop: "-2rem",
              marginBottom: "2rem"
            }}
          >
            {templatesBits.length > 0 && (
              <FlexPagination>
                <Pagination
                  total={totalPages}
                  offset={params.pagination}
                  setDataParams={setParams}
                  dataParams={params}
                />
              </FlexPagination>
            )}
          </div>
        </Container>
      )}
    </>
  );
};

export default ScreenCreateNewProject;
